import { render, staticRenderFns } from "./messageRecord.vue?vue&type=template&id=2fe3228d&scoped=true"
import script from "./messageRecord.vue?vue&type=script&lang=js"
export * from "./messageRecord.vue?vue&type=script&lang=js"
import style0 from "./messageRecord.vue?vue&type=style&index=0&id=2fe3228d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3228d",
  null
  
)

export default component.exports